import initialState  from '../initialState.js';
import { v4 as uuidv4 } from 'uuid';
// import { apiGeneralService } from '@kidjo/kidjo-web-commons-services';
import analyticsService from '../../services/analytics.service';
const state = {
      analyticsData: {...initialState.analytics},
      apiKey:  process.env.VUE_APP_API_KEY,
      analyticsURL: process.env.VUE_APP_ANALYTICS_API,
  }
const  getters = {
    getAnalyticalData(state) {
      return state.analyticsData;
    },
    getApiUrl(state) {
      return state.apiUrl;
    },
    getUserOrigin(state) {
      return state.analyticsData.origin;
    }
}
const mutations = {
    setUserOrigin(state, data) {
      state.analyticsData = Object.assign(state.analyticsData, {
        origin: data
      });
    },
    setAnalyticsData(state, data) {
      state.analyticsData = data;
    },
    setSubscription(state, data) {
      state.analyticsData = Object.assign(state.analyticsData, {
        subscription: data
      });
    },
    setPayment(state, data) {
      state.analyticsData = Object.assign(state.analyticsData, { payment: data });
    },
    setUserInfo(state, data) {
      state.analyticsData = Object.assign(state.analyticsData, data);
    }
  }
const actions = {
  updateUserOrigin({ commit }, data) {
    commit('setUserOrigin', data);
  },
  updatePaymentsPayload({ commit }, data) {
    commit('setPayment', data);
  },
  updateUserPayload({ commit }, data) {
    commit('setUserInfo', data);
  },
  updateSubscriptionPayload({ commit }, data) {
    commit('setSubscription', data);
  },
  postAnalytics({ commit, state }, event) {
      const data = {
        ...state.analyticsData,
        transactionUuid: uuidv4(),
        event
      };

      return analyticsService
        .postAnalytics(
          null,
          data,
          state.apiKey,
          state.analyticsURL
        )
        .then((res) => {
          // Optional success logging
        })
        .catch((err) => {
          console.error(err);
        });
    },
  }

  export default {
    state,
    getters,
    actions,
    mutations
  }